import { render, staticRenderFns } from "./catalog_header.vue?vue&type=template&id=79add05b&vue3"
import script from "./catalog_header.vue?vue&type=script&lang=js&vue3"
export * from "./catalog_header.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports